/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrgCountSummary } from './orgCountSummary';
import { OrgCountDetail } from './orgCountDetail';


export interface RansomwareRecoveryDeploymentOrgsCount { 
    details: Array<OrgCountDetail>;
    summary: OrgCountSummary;
}

